// Standard library imports
import React, { useState } from 'react';
// External library imports
import { get as lodashGet } from 'lodash';
import { Form, Formik } from 'formik';
import Typography from '../../../../components/Typography/Typography';

// Internal module imports
import bidClasses from '../Bidding.module.css';
import allDeviceClasses from '../../../../styles/AllDevices.module.css';
import { getColumnWithSlotSize } from '../../../../utils/biddingHelper';
import Checkbox from '../../../../components/Inputs/Checkbox/Checkbox';

export const OutOfMarket = ({ bid, outOfMarketHours, setOutOfMarketHours, setOpen }) => {
    const length = lodashGet(bid, ['settlement'], []).length;
    const slots = Array.from({ length: length }, (__, i) => i);
    const columns = getColumnWithSlotSize(slots, 8);

    const [hourData, setHourData] = useState(outOfMarketHours);

    const getCheckedhours = (value, productName) => {
        if (value) setHourData([...hourData, productName]);
        else setHourData(hourData.filter((e) => e !== productName));
    };

    const handleSubmit = () => {
        setOutOfMarketHours(hourData);
        setOpen({ status: false });
    };

    return (
        <div className={`${bidClasses.InfoModalContainer}`}>
            <div>
                <div className={bidClasses.InfoModalHeading}>
                    <Typography content={'Select Hours'} size={16} />
                </div>
                <Formik initialValues={{}} onSubmit={handleSubmit}>
                    {({ errors, values }) => (
                        <Form>
                            <div className={bidClasses.TableContainer}>
                                {columns.map((column, colIndex) => (
                                    <table key={colIndex}>
                                        <thead>
                                            <tr>
                                                <th>Product Name</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {column.map((key) => (
                                                <tr key={key}>
                                                    <td className={bidClasses.Flex}>
                                                        <Checkbox
                                                            checked={hourData.includes(lodashGet(bid, ['settlement', key, 'productName'])) ? true : false}
                                                            onChange={(e) => getCheckedhours(e, lodashGet(bid, ['settlement', key, 'productName']))}
                                                        />{' '}
                                                        {lodashGet(bid, ['settlement', key, 'productName'], '--')}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ))}
                            </div>

                            <div className={allDeviceClasses.ButtonContainer}>
                                <div>
                                    <button type="button" className="btn-secondary" onClick={() => setOpen({ status: false })}>
                                        Cancel
                                    </button>
                                </div>
                                <div>
                                    <button type="submit" className="btn-primary">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};
